import React from 'react';
import {
  Box,
  Text,
  VStack,
  HStack,
  Badge,
  Skeleton,
  // SkeletonCircle,
  // SkeletonText,
  useColorModeValue
} from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import dateUtils from "../../utils/formatDate";

const ExpiringSoonPointHistory = ({ 
  expiringSoonPointsTransactions, 
  isLoading, 
  bgColor,
  textColor,
  iconColor 
}) => {
  const { t } = useTranslation();
  const savedLanguage = localStorage.getItem("i18nextLng") || "en";
  const subtleTextColor = useColorModeValue('gray.600', 'gray.400');
  const borderColor = useColorModeValue('gray.200', 'gray.600');

  // // Skeleton loader component
  // const SkeletonItem = () => (
  //   <Box p={3} borderBottomWidth="1px" borderColor={borderColor} width="100%">
  //     <HStack justify="space-between">
  //       <HStack spacing={3}>
  //         <SkeletonCircle size="5" />
  //         <Skeleton height="4" width="100px" />
  //       </HStack>
  //       <Skeleton height="6" width="60px" />
  //     </HStack>
  //     <SkeletonText noOfLines={1} mt={2} skeletonHeight="3" width="70%" />
  //   </Box>
  // );

  return (
    <VStack 
      spacing={0} 
      width="100%" 
      maxHeight="400px" 
      overflowY="auto"
      borderRadius="md"
      borderWidth="1px"
      borderColor={borderColor}
    >
      {isLoading ? (
        Array.from({ length: 3 }).map((_, i) => (
          <Box
            key={i}
            p={3}
            width="100%"
            borderBottomWidth="1px"
            borderColor={borderColor}
            _last={{ borderBottomWidth: 0 }}
          >
            <HStack justify="space-between" mb={1}>
              <HStack spacing={2}>
                <Skeleton height="20px" width="32px" borderRadius="md" />
                <Skeleton height="16px" width="40px" borderRadius="full" />
              </HStack>
              <Skeleton height="16px" width="100px" borderRadius="md" />
            </HStack>
          </Box>
        ))
      ) : expiringSoonPointsTransactions?.length > 0 ? (
        expiringSoonPointsTransactions.map((transaction) => (
          <Box
            key={transaction.transaction_id}
            p={3}
            width="100%"
            borderBottomWidth="1px"
            borderColor={borderColor}
            _last={{ borderBottomWidth: 0 }}
          >
            <HStack justify="space-between" mb={1}>
              <HStack spacing={1}>
                <Text fontSize="md" fontWeight="bold" color={iconColor}>
                  {dateUtils.convertToBurmeseNumerals(transaction.points, savedLanguage)}
                </Text>
                <Badge 
                  colorScheme="gray" 
                  variant="subtle" 
                  fontSize="xs"
                  px={1.5}
                  py={0.5}
                >
                  {t('point')}
                </Badge>
              </HStack>
  
              <HStack spacing={3}>
                <Text fontSize="sm" fontWeight="medium">
                  {t('expired_on', {
                    date: dateUtils.formatDate(transaction?.expiration_date, savedLanguage),
                  })}
                </Text>
              </HStack>
            </HStack>
          </Box>
        ))
      ) : (
        <Box p={4} textAlign="center" width="100%">
          <Text fontSize="sm" color={subtleTextColor}>
            {t('no_expiring_points')}
          </Text>
        </Box>
      )}
    </VStack>
  );  
};

export default React.memo(ExpiringSoonPointHistory);

// import {
//     Box,
//     Text,
//     VStack,
//     HStack,
//     Badge,
//     Icon,
//     Skeleton,
//     SkeletonCircle,
//     SkeletonText
//   } from "@chakra-ui/react";
//   import { FaHourglassEnd } from "react-icons/fa";
//   //import timeAgo from "../../utils/timeAgo";
//   import dateUtils from "../../utils/formatDate";
//   import { useTranslation } from "react-i18next";
  
//   const ExpiringSoonPointHistory = ({ expiringSoonPointsTransactions, isLoading, bgColor, textColor, iconColor }) => {
//     const savedLanguage = localStorage.getItem("i18nextLng") || "en";
//     const {t} = useTranslation();

//     return (
//       <VStack
//         width="100%"
//         spacing={2}
//         borderRadius="xl"
//         overflowY="auto"
//         maxHeight="400px"
//       >
//       {isLoading ? (
//         // Skeleton Loader
//         Array.from({ length: 5 }).map((_, index) => (
//           <Box
//             key={index}
//             p={4}
//             borderRadius="xl"
//             bg={bgColor}
//             color={textColor}
//             borderBottomWidth={2}
//             width="100%"
//           >
//             {/* Main Row - Icon + Details + Points */}
//             <HStack justify="space-between" align="center">
//               {/* Skeleton for Icon & Text */}
//               <HStack spacing={4} align="center">
//                 <SkeletonCircle boxSize="6" />
//                 <Skeleton height="4" width="120px" />
//               </HStack>
    
//               {/* Skeleton for Points Section */}
//               <HStack spacing={1} flex={2} justify="flex-end">
//                 <Skeleton height="8" width="40px" />
//                 <Skeleton height="6" width="50px" />
//               </HStack>
//             </HStack>
    
//             {/* Skeleton for Expired Date Text */}
//             <SkeletonText noOfLines={1} spacing="2" skeletonHeight="3" mt={2} />
//           </Box>
//         ))
//       ) : expiringSoonPointsTransactions?.length > 0 ? (
//         expiringSoonPointsTransactions
//           .map((transaction) => (
//             <Box
//               key={transaction.transaction_id}
//               p={4}
//               borderRadius="xl"
//               bg={bgColor}
//               color={textColor}
//               borderBottomWidth={2}
//               width="100%"
//             >
//               {/* Main Row - Icon + Details + Points */}
//               <HStack justify="space-between" align="center">
//                 <HStack spacing={4} align="center">
//                   <Icon as={FaHourglassEnd} color={iconColor} boxSize={5} />
//                   <Text fontSize="xs" fontWeight="bold">
//                     {transaction?.expiration_date
//                       ? dateUtils.formatDate(transaction?.expiration_date, savedLanguage)
//                         : t('expired')
//                     }
//                   </Text>
//                 </HStack>
    
//                 {/* Points Section */}
//                 <HStack spacing={1} flex={2} justify="flex-end">
//                   <Text color={iconColor} fontSize="xl" fontWeight="bold">
//                     -{dateUtils.convertToBurmeseNumerals(transaction.points, savedLanguage)}
//                   </Text>
//                   <Badge color={iconColor} px={2} py={1} borderRadius="md">
//                     {t('point')}
//                   </Badge>
//                 </HStack>
//               </HStack>
    
//               {/* Expired points datetime ago */}
//               <Text fontSize="xs" color="gray.500" fontWeight="bold" mt={1}>
//                 {transaction?.expiration_date && dateUtils.timeAgo(new Date(transaction.expiration_date), savedLanguage)}
//               </Text>
//             </Box>
//           ))
//       ) : null }
//     </VStack>
    
//     );
//   };
  
//   export default ExpiringSoonPointHistory;
  